import { Loader } from '@googlemaps/js-api-loader'

let signalReady: (loaded: boolean) => void
// ponytail: single app-lifetime load signal; loadGoogleMaps is only called once at startup.
// If a retry path is ever added, replace this with a re-creatable deferred.
const ready = new Promise<boolean>((resolve) => {
  signalReady = resolve
})

/**
 * Resolves true once Google Maps has loaded, false if the load failed.
 * Map components must await this before touching the `google` global.
 */
export function googleMapsReady(): Promise<boolean> {
  return ready
}

export async function loadGoogleMaps(apiKey: string): Promise<void> {
  const loader = new Loader({
    apiKey,
    version: 'quarterly',
  })

  try {
    // All four libraries are load-bearing; partial success would leave maps half-broken,
    // so fail fast rather than settle individually.
    await Promise.all([
      loader.importLibrary('places'),
      loader.importLibrary('drawing'),
      loader.importLibrary('geometry'),
      loader.importLibrary('marker'),
    ])
    signalReady(true)
  } catch (error) {
    signalReady(false)
    throw error
  }
}
